import type { AlertTagVariant } from '~/components/shared'

export type StepSlug = 'personal-info' | 'identity' | 'residence' | 'sole-proprietor' | 'confirmation'
export type StepperStep = {
  label: string
  slug: StepSlug
  content: React.ReactNode
}

export type StepProps = {
  changeStep: (newStep: StepSlug) => void
  isSaveAsDraftOpen: boolean
}

export const KycStatusEnum = {
  new: 10,
  submitted: 20,
  inProgress: 30,
  verified: 40,
  declined: 50,
  archived: 60,
}

export const VerificationStepsEnum = {
  personalInfoStep: 'personalInfoStep',
  identityStep: 'identityStep',
  residenceStep: 'residenceStep',
  soleProprietorStep: 'soleProprietorStep',
  confirmationStep: 'confirmationStep',
} as const

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type JsonStringified<T> = string

export type UploadedFile = { documentUrl: string; fileName: string; documentId: string }

export type CollectedData = {
  personalInfoStep: {
    title: string
    firstName: string
    lastName: string
    nationality: string
    dateOfBirth: string
    address: string
    postCode: string
    country: string
    state: string
    city: string
    identificationNumber: string
    expirationDate: string
    identificationDocumentNotExpires: string
    isSoleProprietor?: string
    soleProprietorVatNo?: string
    soleProprietorTermsAccept?: string
  }
  identityStep: {
    client_identityDocuments: JsonStringified<UploadedFile[]>
  }
  residenceStep: {
    client_residenceProofFiles: JsonStringified<UploadedFile[]>
  }
  soleProprietorStep: {
    client_spTaxDocuments: JsonStringified<UploadedFile[]>
    client_spRegistrationDocuments: JsonStringified<UploadedFile[]>
  }
  confirmationStep: {}
}

// Used to check if user should be redirected to the /verification page
export const needsVerification = (kycStatusId: number) => {
  switch (kycStatusId) {
    case 10: // Not verified
    case 50: // Declined
    case 60: // Expired
      return true
    default:
      return false
  }
}

export const getKycBadgeVariant = (kycStatusId: number): AlertTagVariant => {
  switch (kycStatusId) {
    case 10:
      return 'warning'
    case 20:
    case 30:
      return 'progress'
    case 40:
      return 'success'
    case 50:
    case 60:
      return 'error'
    default:
      return 'generic'
  }
}

export const getIconByKyc = (kycStatusId: number) => {
  switch (kycStatusId) {
    case 20: // Submitted
    case 30: // In progress
      return `/images/kyc-status/new/applied.svg`
    default:
      return `/images/kyc-status/new/verification.svg`
  }
}
